import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "relative text-center py-10"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center py-10"
}

import VehicleSearchBox from '@/components/VehicleSearchBox.vue';
import VehicleSearchSelectList from '@/components/VehicleSearchSelectList.vue';
import Loading from 'vue3-loading-overlay/dist/index';

import { useVehicleSearchStore } from '@/stores/useVehicleSearchStore';
import { usePromise, UsePromiseResult} from '@/composables/usePromise';

import { ref, computed } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByMotorcycleType',
  setup(__props) {

const router = useRouter();

const vehicleStore = useVehicleSearchStore();
const { allTypes } = storeToRefs(vehicleStore);

const allTypesPromise = ref<UsePromiseResult>();

// Computed
const getTypesItems = computed(() => {
  return allTypes.value.slice().map((item) => {
    return {
      label: item,
      value: item,
    };
  });
});

// Methods
function onSelectItem({ value }: { value: string }) {
  router.push({
    name: 'vehicle-search_type',
    query: {
      type: value,
    },
  });
}

if (allTypes.value.length == 0) {
  allTypesPromise.value = usePromise(vehicleStore.getAllTypes());
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VehicleSearchBox, {
    title: _ctx.$t('BIKES-SELECT-TYPE-1')
  }, {
    default: _withCtx(() => [
      _createVNode(_Transition, {
        mode: "out-in",
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "transition ease-in duration 100",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (allTypesPromise.value && allTypesPromise.value.isPending)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(Loading), {
                  color: "var(--color-primary)",
                  "is-full-page": false,
                  width: 30,
                  height: 30,
                  active: ""
                })
              ]))
            : (_unref(allTypes).length === 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.$t('NO-MANUFACTURER-AVAILABLE')), 1))
              : (_openBlock(), _createBlock(VehicleSearchSelectList, {
                  key: 2,
                  items: getTypesItems.value,
                  "search-placeholder": _ctx.$t(_ctx.$t('BIKES-SEARCH-TYPE')),
                  "max-height": "calc(100% - 37px)",
                  "has-search": "",
                  "highlight-search": "",
                  onSelectItem: onSelectItem
                }, null, 8, ["items", "search-placeholder"]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})